module.exports = __webpack_public_path__ + "static/media/slide3.8e1d7805.jpg";